<template>
  <div class="l-container confirm-info mx-auto">
    <div class="top-title ml-2">
        <h3>お知らせ詳細</h3>
    </div>
    <div class="mt-6 mb- divider"></div>
    <div class="main-content flex">
      <div class="left-content m-4">
        <LeftMenuNoti/>
      </div>
      <div class="right-content">
        <div class="c-box m-4">
          <div class="ml-6 mr-6">
            <div class="main-top">
              <div class="main-top-left">
                <div class="item">
                  <span class="date-time">2020.04.02</span>
                  <div class="label label-grey-200">サービスについて</div>
                </div>
              </div>
              <div class="main-top-right">
                <span class="date-time">株式会社ベネフィット・ワン</span>
              </div>
            </div>
            <h3 class="whitespace-nowrap">デジタルクーポンコード・デジタルチケットプランのご利用停止と再開目処について</h3>
            <div class="divider mt-6 mb-6"></div>
            <div class="content">
              <p>
                2月13日に発生した福島県沖を震源とする地震において、被災された皆様には心よりお見舞い申し上げます。<br>
                また、平素よりお世話になっておりますお取引企業様におかれましても、皆様がご無事で、また被害が少ないことお祈りしております。
              </p>
              <p>
                尚、地震の影響により配送における影響が発生しております。<br>
                会員の皆様には大変ご迷惑をお掛けいたしますが、何卒ご了承いただきますようお願い申し上げます。
              </p>
              <p class="mark">記</p>
              <p>
                &emsp;&emsp;運送会社で配送遅延が発生しているお届け地域≫ <br>
                &emsp;&emsp;北海道、青森県、岩手県、秋田県、宮城県、山形県、福島県
              </p>
              <p>
                また、配送元である商品並びにサービスご提供企業が上記該当エリアの場合も、配送が遅延する可能性がございます。<br>
                今後の状況に拠り、変更がある場合がございますので、最新情報に関しては、各社運送会社のホームページをご参照ください。
              </p>
              <div class="refer-web">
                <span class="flex items-center">
                  <div class="square"></div>
                  佐川急便
                </span>
                <a href="#">https://www.sagawa-exp.co.jp/</a>
              </div>
              <div class="refer-web">
                <span class="flex items-center">
                  <div class="square"></div>
                  日本郵便
                </span>
                <a href="#">https://www.post.japanpost.jp/newsrelease/index.html</a>
              </div>
              <div class="refer-web">
                <span class="flex items-center">
                  <div class="square"></div>
                  ヤマト運輸
                </span>
                <a href="#">https://www.kuronekoyamato.co.jp/ytc/customer/</a>
              </div>
              <span>※2月14日15時時点では遅延に関するインフォメーションは出ておりません。</span>
              <div class="mt-6 pb-4">以上</div>
            </div>
          </div>
          </div>
          <div class="meta-item-back m-4">
            <i class="icon icon-bor-arrow-left" />
            <span>お申し込み情報詳細に戻る</span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import {
  LeftMenuNoti
} from '@/components/compound'

export default {
  name: 'bs-inf_01_010',
  components: {
    LeftMenuNoti
  },
  data() {
    return {
      breadcrumb_data: ['トップ', 'お知らせ一覧', 'デジタルクーポンコード・デジタルチケットプランのご利用停止と再開目処について']
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";

.nav {
  width: 100%;
}


</style>